import { useEffect } from 'react';
import { NotificationType } from '../../../config';
import itemService from '../../../service/item.service';
import addNotification from '../../../utils/addNotification';
import { AutoCompleteSelectUI, FormErrorUI, FormLabelUI, InputUI } from '../../Interface';
import { Field, useFormikContext } from 'formik';

const ItemAddDialogFields = ({ autoCompleteOptions, autoCompleteData }) => {
  const { values, validateField, setFieldValue, errors } = useFormikContext();

  const handleGenerateItemCode = async (itemGroupId = values.itemGroupId ?? null) => {
    const response = await itemService.generateItemCode(itemGroupId);
    const generatedItemCode =
      response?.itemCode ??
      response?.code ??
      response?.data?.itemCode ??
      response?.data?.code ??
      (typeof response === 'string' ? response : null);

    if (!generatedItemCode) {
      addNotification({
        content: 'A cikkszám generálása sikertelen!',
        type: NotificationType.ERROR,
      });
      return;
    }

    await setFieldValue('itemCode', generatedItemCode);
    validateField('itemCode');
  };

  useEffect(() => {
    handleGenerateItemCode(values.itemGroupId ?? null);
  }, [values.itemGroupId]);

  return (
    <div className="grid grid-cols-6 gap-x-4 gap-y-3 lg:mx-4 mb-5 mt-2">
      <div className="col-span-3">
        <Field
          type="text"
          name="itemName"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Cikknév" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.itemName} />}
          InputLabelProps={{ shrink: values.itemName !== '' }}
        />
      </div>
      <div className="col-span-3">
        <Field
          type="autocomplete"
          name="itemGroupId"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Cikkcsoport" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.itemGroupId} />}
          onChange={(_e, newVal) => {
            const findedGroup = autoCompleteData.itemGroup.find((i) => i.id === newVal?.value);
            const findedME = autoCompleteData.quantityUnit.find((i) => findedGroup?.quantityUnitId === i?.id);

            setFieldValue('weight', findedME?.weight ?? '');
            setFieldValue('quantityUnitId', findedGroup?.quantityUnitId ?? null);
            setFieldValue('type', findedGroup?.type ?? null);
            setFieldValue('landedCost', false);
            setFieldValue('stockItemType', findedGroup?.stockItemType ?? null);
            setFieldValue('inPurchase', findedGroup?.inPurchase ?? null);
            setFieldValue('inSales', findedGroup?.inSales ?? null);

            setFieldValue('itemGroupId', newVal?.value ?? null).then(() => {
              validateField('itemGroupId');
            });
          }}
          InputLabelProps={{ shrink: values.itemGroupId !== '' }}
          selectedValue={values.projecitemGroupIdtTypeId}
          dataset={autoCompleteOptions.itemGroup}
        />
      </div>
    </div>
  );
};

export default ItemAddDialogFields;
